<div class="passwordContainer">
    <mat-card class="mat-elevation-z2" [ngClass]="{'loginCard ': !(isHandset$ | async) , 'loginCardHandset': (isHandset$ | async) }" >
     
      <form id="formContainer"  [formGroup]="passwordForm" >
        <div  [ngClass]="{'headerImageWeb': !(isHandset$ | async) , 'headerImageHandset': (isHandset$ | async) }" class="headerFlex"  style="display: flex">
          <img src="assets/logo.png" alt="MDR logo" >
      </div>
      <div style="display: flex; color: #000000; opacity: 0.8; padding-top: 20px;" class="mat-display-4">
        Vanuatu Medical Disability Registry
       </div>
      <div style="display: flex; color: #000000; opacity: 0.8; padding-top: 28px;" class="mat-subheading-1">
        Enter the password
       </div>
          <mat-form-field class="example-full-width" appearance="outline" style="width: 80%; padding-top: 40px;">
            <mat-label>Password</mat-label>
            <input (focus)="this.passwordForm.controls['password'].markAsTouched();" (keydown.space)="$event.preventDefault()" matInput maxlength="15" #passwordInput 
            [type]="hide ? 'password' : 'text'" formControlName="password" (keypress)="keyPressPassword($event)">
            <div  style="cursor:pointer" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" >
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
      
            <mat-hint class="error-hint"  [ngClass]="{'error-hint': (this.passwordForm.controls['password'].hasError('invalidPassword') 
            && this.passwordForm.controls['password'].touched) , 'normal-hint': !(this.passwordForm.controls['password'].hasError('invalidPassword') 
            && this.passwordForm.controls['password'].touched) }">
           <span> 8-15 characters, with at least one number, special, uppercase, and lowercase characters</span>
            </mat-hint>
        </mat-form-field>
        <div class="action-area" style="padding-top: 44px;">
          <button  (click)="onSubmit()" mat-raised-button [ngClass]="{'login-btn': !this.passwordForm.invalid ,'login-btn-disabled':this.passwordForm.invalid}" [disabled]="this.passwordForm.invalid">
             <span [ngClass]="{'mat-button': !this.passwordForm.invalid ,'mat-button-disabled':this.passwordForm.invalid}">VERIFY</span>
          </button>
        </div>
        <div class="action-area" style="padding-top: 20px;">
          <button  (click)="forgotPassword()" mat-raised-button style="background-color: #7E9689;"> <span style="color: #000000; opacity: 0.87;">FORGOT PASSWORD</span> </button>
        </div>
        <div style="padding-top: 20px;"><span class="mat-body-2 back"  (click)="back()">BACK</span></div>
    </form>
    </mat-card>
    
    </div>
    